const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    alignSelf: 'stretch',
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  header: {
    color: 'var(--mcg-darkgray, #282F35)',
    /* Body/Body 2 */
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 24px */,
  },
  headerContainer: {
    flex: '1 0 0',
  },
  type: {
    color: 'var(--Gray-Darker, #838D98)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
  typeContainer: {
    display: 'flex',
    height: '21px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  button: {
    borderRadius: '6px',
    background: 'var(--mcg-white, #FFF)',
    display: 'flex',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '7px var(--12, 12px)',
    cursor: 'pointer',
  },
  buttonText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFeatureSettings: `'liga' off, 'clig' off`,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '18px' /* 150% */,
  },
  imageHeader: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 4 */
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 21px */,
  },
  imageText: {
    color: 'var(--mcg-gray, #919EAB)',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
  imageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
  background: {
    display: 'flex',
    height: '200px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '12px',
  },
  positionContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
  },
  positionContent: {
    display: 'flex',
    padding: '20px 32px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  positionDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
  },
  positionText: {
    overflow: 'hidden',
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    /* Body/Body 6 */
    fontFamily: 'Inter',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '18px' /* 163.636% */,
  },
})

export default styles
